import React from 'react';

import { InputNumber } from 'antd';

import { IBVControl } from '../../../models/BVControls/IBVControl';

import './bv-input-number.scss';

import BVControl from '../BVControl/bv-control';

interface IBVInput extends IBVControl {
    properties: any;
    isEmbedded?: boolean;
}

const BVInputNumber: React.FunctionComponent<IBVInput> = ({ className, errorMessage, infoMessage, label, properties, required, isEmbedded }) => (
    <BVControl className={`bv-input-number ${className}`} errorMessage={errorMessage} infoMessage={infoMessage} label={label} required={required}>
        <InputNumber
            style={{maxWidth: isEmbedded ? "none" : "300px"}}
            {...properties}
        />
    </BVControl>
);

export default BVInputNumber;